<template>
  <div v-if="isLoading">
    <LoadingPlaceholder/>
  </div>
  <div v-else>
    <Breadcrumbs
      :breadcrumbs="[
     {title: this.$t(`menu.${serviceSlug}`), disabled: true},
     {title: this.$t('menu.iframe/project-builder'), active: true, meta: {type: 'string', value: `/${this.iframeService.slug}/${this.iframeService.slug}/project-builder`}},
     {title: flow.name, disabled: true}
   ]"/>

    <div>
      <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3"> {{$t('iframe.titles.update_flow', {name: flow.name})}} </h5>

      <ProjectDetails
        @redrawComponents="$forceUpdate()"
        :form-errors="flowErrors"
        :clientOptions="writeEntities"
        v-model="flowForm.data.details"
        :collapsable="true"
      />

      <ProjectStyles
        v-if="flowForm.data.details.client"
        ref="projectStyles"
        :form-errors="flowErrors"
        v-model="flowForm.data.styles"
        :client="flowForm.data.details.client"
        :collapsable="true"
      />

      <Legal
        v-if="flowForm.data.details.client"
        :form-errors="flowErrors"
        v-model="flowForm.data.legal"
        :collapsable="true"
      />

      <PagesConfigurator
        v-if="flowForm.data.details.client"
        ref="pagesConfigurator"
        :form-errors="flowErrors"
        :pages="pages"
        v-model="flowForm.data.pages"
        :client="flowForm.data.details.client"
        :collapsable="true"
        />

      <!-- Buttons row -->
      <div class="row d-flex justify--space-between mt-3 ml-3 mr-3">
        <va-button class="btn-cancel" @click="handleCancel">
          {{$t('iframe.actions.cancel')}}
        </va-button>

        <va-button @click="handleSave" :disabled="!canSubmit">
          {{$t('iframe.actions.save')}}
        </va-button>
      </div>
      <!-- --- --- --- -->


    </div>

  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import {IframeService} from "@/api/IframeService";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";
import ProjectDetails from "@/components/iframe/project-builder/ProjectDetails";
import ProjectStyles from "@/components/iframe/project-builder/ProjectStyles";
import Legal from "@/components/iframe/project-builder/Legal";
import PagesConfigurator from "@/components/iframe/project-builder/PagesConfigurator";
import Errors from "@/utils/StandardErrors";

const errorsPrefix = 'iframe.flows.errors.'
export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
  },
  components: {PagesConfigurator, ProjectStyles, ProjectDetails, LoadingPlaceholder, Breadcrumbs, Legal},
  data() {
    return {
      isLoading: true,
      isSubmiting: false,
      flowForm: {
        data: {
          details: {
            name: null,
            client: {},
            url: null,
            hash: null,
            lang: null,
            country: null,
            adjust_volume_text: null,
            adjust_volume_audio: null,
            default_output_source: null,
            override_redirect_url: null,
            auto_scroll_to_begin_of_page: null,
            biosigns_monthly_limit_scans: 0,
          },
          styles: {
            text_size: null,
            primary: null,
            primary_dark_20: null,
            primary_dark_40: null,
            primary_dark_50: null,
            secondary: null,
            secondary_light_20: null,
            logos: []
          },
          legal: {
            acceptance_text: null,
            acceptance_text_order: null,
            marketing_text: null,
            marketing_text_order: null,
            to_partner_text: null,
            to_partner_text_order: null,
            terms_text: null,
            terms_url: null,
            consent_intro: null,
          },
          pages: []
        },
      },
      flow: null,
      pages: [],
      flowErrors: new Errors()
    }
  },
  async mounted() {
    try {
      const resp = await IframeService.getFlowByHash(this.$route.params.id)
      this.flow = resp.data
      const pagesResp = await IframeService.getPages()
      this.pages = pagesResp.data
      this.isLoading = false
      this.prefillForm()
    } catch (err) {
      //todo handle err
      console.log(err)
    }
  },
  methods: {
    prefillForm: function() {
      this.flowForm.data.details = {...this.flow}
      this.flowForm.data.styles = {...this.flow.colors}
      this.flowForm.data.styles.logos = this.flow.logos
      this.flowForm.data.styles.text_size = this.flow.text_size
      this.flowForm.data.pages = [...this.flow.pages]

      const outputSourcesOptions = [
        {
          id:0,
          source: null,
          label: this.$t('iframe.flows.output_sources.default_both')
        },
        {
          id:1,
          source: 'headphones',
          label: this.$t('audiology_4_all.values.outputType.headphones')
        },
        {
          id:2,
          source: 'computer',
          label: this.$t('audiology_4_all.values.outputType.speakers')
        },
      ]
      this.flowForm.data.details.default_output_source = outputSourcesOptions.filter(elem => elem.source === this.flowForm.data.details.default_output_source)

      if(this.flowForm.data.details && this.flowForm.data.details.lang) {
        this.flowForm.data.details.lang = this.$store.state.languages.filter(lang => lang.lang === this.flowForm.data.details.lang)[0] || null
      }

      if (this.flowForm.data.details && this.flowForm.data.details.client_id) {this.flowForm.data.details.client = this.writeEntities.filter(ent => ent.id === parseInt(this.flowForm.data.details.client_id))[0] || null
      }
      this.flowForm.data.legal = {...this.flow}
      //this.flowForm.data.pages = this.flow.hasOwnProperty('pages') ? this.flow.pages : []
    },
    handleCancel: function() {
      this.$router.push({path:`/${this.iframeService.slug}/${this.iframeService.slug}/project-builder`})
    },
    handleSave: function() {
      if(Object.keys(this.flowErrors.errors).length > 0) {
        this.showToast(this.$t('iframe.flows.update_error'), this.$store.state.errorToastOptions)
        return
      }
      if (this.canSubmit) {
        this.isSubmiting = true

        let formDataToSubmit = {}

        formDataToSubmit.id = this.flowForm.data.details.id
        formDataToSubmit.name = this.flowForm.data.details.name
        if (this.flowForm.data.details.client) {
          formDataToSubmit.client_id = parseInt(this.flowForm.data.details.client.id)
        }
        formDataToSubmit.hash = this.flowForm.data.details.hash
        if(this.flowForm.data.details.country) {
          formDataToSubmit.country = this.flowForm.data.details.country.code
        }

        if (this.flowForm.data.details.lang) {
          formDataToSubmit.lang = this.flowForm.data.details.lang.lang
        }
        if(this.flowForm.data.details.default_output_source) {
          formDataToSubmit.default_output_source = this.flowForm.data.details.default_output_source.source
        }
        formDataToSubmit.adjust_volume_text = this.flowForm.data.details.adjust_volume_text
        formDataToSubmit.text_size = this.flowForm.data.styles.text_size
        formDataToSubmit.colors= {...this.flowForm.data.styles}

        if (this.$refs.projectStyles.selectedLogos.length > 0) {
          formDataToSubmit.logos = this.$refs.projectStyles.selectedLogos.map(logo => parseInt(logo.id))
        }
        if(this.$refs.pagesConfigurator.addedPages.length > 0) {
          formDataToSubmit.pages = this.$refs.pagesConfigurator.addedPages.map(page => parseInt(page.page.id))
        }

        formDataToSubmit.acceptance_text = this.flowForm.data.legal.acceptance_text
        formDataToSubmit.acceptance_text_order = this.flowForm.data.legal.acceptance_text_order
        formDataToSubmit.marketing_text = this.flowForm.data.legal.marketing_text
        formDataToSubmit.marketing_text_order = this.flowForm.data.legal.marketing_text_order
        formDataToSubmit.to_partner_text = this.flowForm.data.legal.to_partner_text
        formDataToSubmit.to_partner_text_order = this.flowForm.data.legal.to_partner_text_order
        formDataToSubmit.terms_text = this.flowForm.data.legal.terms_text
        formDataToSubmit.terms_url = this.flowForm.data.legal.terms_url
        formDataToSubmit.consent_intro = this.flowForm.data.legal.consent_intro
        formDataToSubmit.override_redirect_url = this.flowForm.data.details.override_redirect_url
        formDataToSubmit.auto_scroll_to_begin_of_page = this.flowForm.data.details.auto_scroll_to_begin_of_page
        formDataToSubmit.biosigns_monthly_limit_scans = this.flowForm.data.details.biosigns_monthly_limit_scans

        formDataToSubmit.adjust_volume_audio = this.flowForm.data.details.adjust_volume_audio
        let formData
        if (formDataToSubmit.adjust_volume_audio !== null) {
          formData = new FormData()
          formData.append('sound', formDataToSubmit.adjust_volume_audio)
        } else {
          formData = null
        }

        IframeService.updateFlow(formDataToSubmit.id, formDataToSubmit)
          .then(res => {
            IframeService.updateAdjustVolumeAudio(formDataToSubmit.id, formData)
              .then(result => {
                this.showToast(this.$t('iframe.flows.update_success'), this.$store.state.successToastOptions)
                this.handleCancel()
              })
              .catch(error => {
                console.log(error)
                if(error.response.status === 422) {
                  this.flowErrors.record(error.response.data.errors, errorsPrefix)
                }
                this.showToast(this.$t('iframe.flows.update_error'), this.$store.state.errorToastOptions)
              })
          })
          .catch(err => {
            console.log(err)
            if(err.response.status === 422) {
              this.flowErrors.record(err.response.data.errors, errorsPrefix)
            }
            this.showToast(this.$t('iframe.flows.update_error'), this.$store.state.errorToastOptions)
          })
          .finally(() => {
            this.isSubmiting = false
          })
      }

    }
  },
  computed: {
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
      //return this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
    },
    flowPermissions: function () {
      return this.iframeService.user_permissions.filter(permission => permission.access_type >= 2 && permission.info_type === 100)
    },
    entities: function () {
      //let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      if (this.iframeService) {
        return this.iframeService.entities
      }
      return null
    },
    writeEntities: function () {
      return this.entities.filter(entity => this.flowPermissions.some(permission => permission.entity_id === null || permission.entity_id === entity.id)) || []
    },
    canSubmit: function () {
      return this.isLoading ? false : (this.flowForm.data.details.name !== null && this.flowForm.data.details.name !== '')
        && (this.flowForm.data.details.lang !== null)
        && (this.flowForm.data.details.hash !== null && this.flowForm.data.details.hash !== '')
        //&& (this.$refs.pagesConfigurator !== undefined && this.$refs.pagesConfigurator.addedPages.length > 0)
        && !this.isSubmiting
    },
  }
}
</script>

<style scoped>

</style>
